import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

const images = [
  { src: '/assets/images/pattu-soft-silk-saree-1.jpeg', thumb: '/assets/images/pattu-soft-silk-saree-1.jpeg', subHtml: '<h4>Caption 1</h4>' },
  { src: '/assets/images/royal-rajwari-katan-silk.jpeg', thumb: '/assets/images/gucci-perfume-247x296.webp', subHtml: '<h4>Caption 2</h4>' },
  // ... more images
];

const GalleryComponent = (    ) => {
  return (    
    <section data-bs-version="5.1" className="gallery4 mbr-gallery shopm5 cid-tDSBxBBmuX" id="agallery4-a">  
   
    <div className="row mbr-gallery items-row justify-content-center">
        <div className="col-12 col-md-6 col-lg-4 col-xl-2 item gallery-image active">
            <div className="item-wrapper" data-toggle="modal" data-bs-toggle="modal" data-target="#v1Xcarx2mC-modal" data-bs-target="#v1Xcarx2mC-modal">
                <img className="w-100" src="assets/images/01.webp" alt="" data-slide-to="0" data-bs-slide-to="0" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC" />
                <div className="img-overlay"></div>
                <div className="icon-wrapper">
                    <span className="mobi-mbri mobi-mbri-search mbr-iconfont mbr-iconfont-btn"></span>
                </div>
            </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 col-xl-2 item gallery-image">
            <div className="item-wrapper" data-toggle="modal" data-bs-toggle="modal" data-target="#v1Xcarx2mC-modal" data-bs-target="#v1Xcarx2mC-modal">
                <img className="w-100" src="assets/images/02.webp" alt="" data-slide-to="1" data-bs-slide-to="1" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC" />
                <div className="img-overlay"></div>
                <div className="icon-wrapper">
                    <span className="mobi-mbri mobi-mbri-search mbr-iconfont mbr-iconfont-btn"></span>
                </div>
            </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 col-xl-2 item gallery-image">
            <div className="item-wrapper" data-toggle="modal" data-bs-toggle="modal" data-target="#v1Xcarx2mC-modal" data-bs-target="#v1Xcarx2mC-modal">
                <img className="w-100" src="assets/images/03.webp" alt="" data-slide-to="2" data-bs-slide-to="2" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC" />
                <div className="img-overlay"></div>
                <div className="icon-wrapper">
                    <span className="mobi-mbri mobi-mbri-search mbr-iconfont mbr-iconfont-btn"></span>
                </div>
            </div>
        </div><div className="col-12 col-md-6 col-lg-4 col-xl-2 item gallery-image">
            <div className="item-wrapper" data-toggle="modal" data-bs-toggle="modal" data-target="#v1Xcarx2mC-modal" data-bs-target="#v1Xcarx2mC-modal">
                <img className="w-100" src="assets/images/mbr-618x412.webp" alt="" data-slide-to="3" data-bs-slide-to="3" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC" />
                <div className="img-overlay"></div>
                <div className="icon-wrapper">
                    <span className="mobi-mbri mobi-mbri-search mbr-iconfont mbr-iconfont-btn"></span>
                </div>
            </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 col-xl-2 item gallery-image">
            <div className="item-wrapper" data-toggle="modal" data-bs-toggle="modal" data-target="#v1Xcarx2mC-modal" data-bs-target="#v1Xcarx2mC-modal">
                <img className="w-100" src="assets/images/mbr-2-1920x1280.webp" alt="" data-slide-to="4" data-bs-slide-to="4" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC" />
                <div className="img-overlay"></div>
                <div className="icon-wrapper">
                    <span className="mobi-mbri mobi-mbri-search mbr-iconfont mbr-iconfont-btn"></span>
                </div>
            </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 col-xl-2 item gallery-image">
            <div className="item-wrapper" data-toggle="modal" data-bs-toggle="modal" data-target="#v1Xcarx2mC-modal" data-bs-target="#v1Xcarx2mC-modal">
                <img className="w-100" src="assets/images/mbr-872x569.webp" alt="" data-slide-to="5" data-bs-slide-to="5" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC" />
                <div className="img-overlay"></div>
                <div className="icon-wrapper">
                    <span className="mobi-mbri mobi-mbri-search mbr-iconfont mbr-iconfont-btn"></span>
                </div>
            </div>
        </div>
    </div>

    <div className="modal mbr-slider" style={{tabindex:'-1'}} role="dialog" aria-hidden="true" id="v1Xcarx2mC-modal">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-body">
                    <div className="carousel slide" id="lb-v1Xcarx2mC" data-interval="5000" data-bs-interval="5000">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img className="d-block w-100" src="assets/images/01.webp" alt="" />
                            </div><div className="carousel-item">
                                <img className="d-block w-100" src="assets/images/02.webp" alt="" />
                            </div><div className="carousel-item">
                                <img className="d-block w-100" src="assets/images/03.webp" alt="" />
                            </div><div className="carousel-item">
                                <img className="d-block w-100" src="assets/images/mbr-618x412.webp" alt="" />
                            </div>
                            <div className="carousel-item">
                                <img className="d-block w-100" src="assets/images/mbr-2-1920x1280.webp" alt="" />
                            </div>
                            <div className="carousel-item">
                                <img className="d-block w-100" src="assets/images/mbr-872x569.webp" alt="" />
                            </div>
                            
                            
                            
                        </div>
                        <ol className="carousel-indicators">
                            <li data-slide-to="0" data-bs-slide-to="0" className="active" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC"></li>
                            <li data-slide-to="1" data-bs-slide-to="1" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC"></li>
                            <li data-slide-to="2" data-bs-slide-to="2" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC"></li>
                            <li data-slide-to="3" data-bs-slide-to="3" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC"></li>
                            <li data-slide-to="4" data-bs-slide-to="4" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC"></li>
                            <li data-slide-to="5" data-bs-slide-to="5" data-target="#lb-v1Xcarx2mC" data-bs-target="#lb-v1Xcarx2mC"></li>
                        </ol>
                        <a role="button" href="" className="close" data-dismiss="modal" data-bs-dismiss="modal" aria-label="Close">
                        </a>
                        <a className="carousel-control-prev carousel-control" role="button" data-slide="prev" data-bs-slide="prev" href="#lb-v1Xcarx2mC">
                            <span className="mobi-mbri mobi-mbri-arrow-prev" aria-hidden="true"></span>
                            <span className="sr-only visually-hidden visually-hidden">Previous</span>
                        </a>
                        <a className="carousel-control-next carousel-control" role="button" data-slide="next" data-bs-slide="next" href="#lb-v1Xcarx2mC">
                            <span className="mobi-mbri mobi-mbri-arrow-next" aria-hidden="true"></span>
                            <span className="sr-only visually-hidden visually-hidden">Next</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  );
};

export default GalleryComponent;